<template>
    <div class="row">
        <div class="col-12">
            <h4>Id: {{id}}</h4>
        </div>
    </div>
</template>
<script>
import FormInput from '../../../../../Shared/UI/Form/FormInput.vue';
import { required } from 'vuelidate/lib/validators';

export default {
    name: 'id-data',
    components: {FormInput},
    props: {
        id: {}
    },
    validations: {
        id: {
            required
        }
    }
};
</script>
